export default {
  init() {
    // JavaScript to be fired on the home page
    $.scrollIt({
      upKey: 38,             // key code to navigate to the next section
      downKey: 40,           // key code to navigate to the previous section
      easing: 'linear',      // the easing function for animation
      scrollTime: 50,       // how long (in ms) the animation takes
      activeClass: 'current', // class given to the active nav element
      onPageChange: null,    // function(pageIndex) that is called when page is changed
      topOffset: 0,         // offste (in px) for fixed top navigation
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const body = document.querySelector('body');
    const loader = document.getElementById('loader');
    const logo = document.getElementById('logo');

    window.onload = function() {

      body.animate([
        {opacity: 0},
        {opacity: 1},
      ], {
        duration: 300,
        fill: 'forwards',
      });

      animateLogo();
      homeAnimation();
    }

    function homeAnimation() {
      loader.animate([
        // keyframes
        { transform: 'translateY(0px)' },
        { transform: 'translateY(-100%)' },
      ], {
        // timing options
        duration: 600,
        easing: 'ease',
        iterations: 1,
        fill: 'forwards',
        delay: 1200,
      });
    }

    function animateLogo() {
      logo.animate([
        // keyframes
        { width: '100%' },
        { width: '116px' },
      ], {
        // timing options
        duration: 600,
        easing: 'ease-out',
        iterations: 1,
        fill: 'forwards',
        delay: 600,
      });
    }

    /* const slides = document.querySelectorAll('.slide');
    const slideNav = document.getElementById('slide-nav');
    const slideNavItem = document.getElementById('pip');
    const slidesContainer = document.getElementById('slides');
    const windowHeight = window.innerHeight;
    const slidesBottom = slidesContainer.getBoundingClientRect();
    //console.log('windowHeight ' + windowHeight);
    //console.log(slidesBottom);

    slides[0].classList.add('in-view');

    document.addEventListener('scroll', function() {
      //console.log(window.scrollY);
      //console.log('bottom' + slidesBottom);
      slides.forEach(function(slide, index) {
        let slideNum = slides.length;
        let offsetContact = windowHeight - 1;
        let offsetSlide = windowHeight / 2;
        let slidePosition = slide.offsetTop - offsetSlide;
        let contactPosition = slide.offsetTop - offsetContact;
        if(window.scrollY >= slidePosition && window.scrollY <= slidePosition + windowHeight) {
          slide.classList.add('in-view');
        } else {
          slide.classList.remove('in-view');
        }

        if(window.scrollY >= contactPosition) {
          if(index === slides.length - 1) {
            slidesContainer.classList.add('scrolled-by');
            slideNav.classList.add('last-slide');
          }
        } else {
          if(index === slides.length - 1) {
            slidesContainer.classList.remove('scrolled-by');
            slideNav.classList.remove('last-slide');
          }
        }
        //console.log(slide.offsetTop);
        //console.log(window.scrollY);

      });
    }); */
    if($('#slides').length) {
      $('html, body').addClass('op-scroll');
      $('#slides').onepage_scroll({
        sectionContainer: '.slide',     // sectionContainer accepts any kind of selector in case you don't want to use section
        easing: 'ease',                  // Easing options accepts the CSS3 easing animation such "ease", "linear", "ease-in",
                                          // "ease-out", "ease-in-out", or even cubic bezier value such as "cubic-bezier(0.175, 0.885, 0.420, 1.310)"
        animationTime: 800,             // AnimationTime let you define how long each section takes to animate
        pagination: true,                // You can either show or hide the pagination. Toggle true for show, false for hide.
        updateURL: false,                // Toggle this true if you want the URL to be updated automatically when the user scroll to each page.
        beforeMove: function(index) {},  // This option accepts a callback function. The function will be called before the page moves.
        afterMove: function(index) {
          if($('#slides .slide:last-child').hasClass('active')) {
            $('.home--contact').addClass('hide');
          }
          else {
            $('.home--contact').removeClass('hide');
          }
        },   // This option accepts a callback function. The function will be called after the page moves.
        loop: false,                     // You can have the page loop back to the top/bottom when the user navigates at up/down on the first/last page.
        keyboard: true,                  // You can activate the keyboard controls
        responsiveFallback: false,        // You can fallback to normal page scroll by defining the width of the browser in which
                                          // you want the responsive fallback to be triggered. For example, set this to 600 and whenever
                                          // the browser's width is less than 600, the fallback will kick in.
        direction: 'vertical',            // You can now define the direction of the One Page Scroll animation. Options available are "vertical" and "horizontal". The default value is "vertical".  
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js